export { PackageExtrasTemplate } from './PackageExtrasTemplate';
export type {
  PackageExtrasTemplateLabels,
  PackageExtrasTemplateProps,
} from './PackageExtrasTemplate.types';
